<template>
  <div class="week-by-car-num">
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <div class="wrapper">
      <div style="font-weight: bold">加能站停靠统计</div>
      <WeekStatisticsTip />
<!--      <exportDate v-if="showExport" @hideExport="showExport = false" :moduleName="moduleName"/>-->
<!--      :provinCode="provinceCode"-->
      <dimension-dialog v-if="showExport" :params="params" @hideExport="showExport = false" tabNames="monthly" :moduleName="moduleName" :autoChunkMonth="true"/>
      <div class="header">
        <el-form :inline="true">
<!--          <el-form-item label="统计月份">-->
<!--            <el-date-picker-->
<!--                v-model="formData.time"-->
<!--                type="month"-->
<!--                format="yyyy年MM月"-->
<!--                value-format="yyyyMM"-->
<!--                placeholder="选择月">-->
<!--            </el-date-picker>-->
<!--          </el-form-item>-->
          <el-form-item label="统计周" label-width="75px">
            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>
          </el-form-item>
          <el-form-item label="站点类型" label-width="75px">
            <el-select v-model="formData.zhanDianType" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in zhanDianOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="吨位区间" label-width="75px">
            <el-select v-model="formData.dunwei" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in dunWeiOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="燃料类型" label-width="75px">
            <el-select v-model="formData.ranliaoType" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in ranliaoOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button style="margin-left:10px;" @click="onDebounceSearch" class="searchBtn">查询</el-button>
<!--          <el-button v-show="hideExport" style="margin-left:10px;" @click="exFun">导出</el-button>-->
          <el-button v-show="hideExport" style="margin-left:10px;" @click="exportData">导出查询结果</el-button>
          <el-button style="margin-left:10px;" @click="showWeekDialog = true">导出全部明细</el-button>
        </el-form>
      </div>
      <WeekDialog @on-command="onWeekDialogCommand" v-if="showWeekDialog"/>
      <el-table ref="singleTable" :data="tableData" :max-height="tableHeight1" stripe style="width: 100%">
<!--        <el-table-column type="index" fixed label="序号" align="center" width="50" fixed="left"/>-->
        <el-table-column prop="provname" label="统计省份" align="center"></el-table-column>
        <el-table-column prop="stopCount" min-width="220" label="全部油站停靠次数(次)" align="center"></el-table-column>
        <el-table-column prop="sinopecStopCount" min-width="220" label="S级油站停靠次数(次)" align="center"></el-table-column>
        <el-table-column prop="sinopecStopCountRate" min-width="220" label="S级油站停靠占比" align="center"></el-table-column>
        <el-table-column prop="petrochinaStopCount" min-width="220" label="C级油站停靠次数(次)" align="center"></el-table-column>
        <el-table-column prop="petrochinaStopCountRate" min-width="220" label="C级油站停靠占比" align="center"></el-table-column>
        <el-table-column prop="stopGasCount" min-width="220" label="O级油站停靠次数(次)" align="center"></el-table-column>
        <el-table-column prop="stopGasCountRate" min-width="220" label="O级油站停靠占比" align="center"></el-table-column>
        <el-table-column prop="otherStopCount" min-width="220" label="E级油站停靠次数(次)" align="center"></el-table-column>
        <el-table-column prop="otherStopCountRate" min-width="220" label="E级油站停靠占比" align="center"></el-table-column>
        <el-table-column label="" align="center" fixed="right" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.provname!='合计'" style="color:#1137FF;cursor: pointer;" @click="getCityDataValXia(scope.row)">下辖地区统计</span>
          </template>
        </el-table-column>
        <el-table-column label="" align="center" fixed="right" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.provname!='合计'" style="color:#1137FF;cursor: pointer;" @click="getCityDataVal(scope.row)">车辆来源统计</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBlock">
        <el-pagination @current-change="onChangePage" :current-page.sync="index" :page-size="pageSize"
                       layout="prev, pager, next, jumper" :total="total" style="margin:auto;"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import http from '@/api/freight.js' //请求汇总
import _ from 'lodash'
// import areaList from './components/areaList'
import detailCard from '@/components/detailCard.vue'
import WeekPopover from './components/weekPopover.vue'
import WeekDialog from './components/weekDialog.vue'
import Util from '@/utils/util'
import devLog from "components/devLog.vue";
import seeTopFive from "components/seeTopFive.vue";
import {hideExport} from "utils/tools";
import dimensionDialog from "components/exportDate/daphne/dialog.vue";
import Cookies from "js-cookie";
import {collectAnalysisCustomerEx2, exportProvinceWSimplify, progress} from "api/log";
import WeekStatisticsTip from "@/components/WeekStatisticsTip.vue";

export default {
  name: 'week-by-car-num',
  components: {dimensionDialog, seeTopFive, devLog, WeekPopover, WeekDialog, detailCard, WeekStatisticsTip},
  data() {
    return {
      // moduleName: 'pathwayProvinceOil',
      moduleName: 'oilStationBerthCountV2',
      hideExport: hideExport,
      showExport: false, //控制批量导出
      tableHeight1: this.tableHeight,
      nrData: {},
      ranliaoOption:Util.ranLiaoOption,
      dunWeiOption: Util.dunWeiOption,
      zhanDianOption:Util.zhanDianOption,
      showWeekDialog:false,
      mark: false, //遮罩层开关
      progressNum: 0, //下载进度条进度
      formData: {
        time: '',
        dunwei:[],
        ranliaoType:[],
        zhanDianType:[],
        zhanDianBrand:[],
        sourceGastype:'1',
      },
      tableCol: [
        {
          name: '运营车辆数',
          children: [
            {name: '全部车辆', prop: 'runCarNum0'},
            {name: '柴油车辆', prop: 'runCarNum1'},
            {name: 'LNG车辆', prop: 'runCarNum2'},
            {name: '新能源车辆', prop: 'runCarNum3'},
          ],
        },
        {
          name: '运营里程',
          children: [
            {name: '全部车辆', prop: 'totalMile0'},
            {name: '柴油车辆', prop: 'totalMile1'},
            {name: 'LNG车辆', prop: 'totalMile2'},
            {name: '新能源车辆', prop: 'totalMile3'},
          ],
        },
      ],

      curDate: '',
      tableData: [],
      onDebounceSearch: _.debounce(this.onSearch, 500),
      total: 0, // 总页数
      index: 1, // 当前页数
      pageSize: 20,
      areaListPr: '',
      params:{}
    }
  },
  mounted() {
    let value4=Util.lastTime(new Date());
    let arr = value4.split('-')
    this.formData.time=arr[0]+''+arr[1]
    // this.getData(1)
  },
  methods: {
    exportData() {
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      reqId += new Date() * 1
      let times
      times = setInterval(function () {
        progress({reqId}).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            clearInterval(times)
            that.progressNum = 100
            setTimeout(function () {
              that.mark = false
              that.progressNum = 0
            }, 500);
          }
        })
      }, 200)

      let curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
      if (!curSelectedWeek) {
        this.$message({
          message: '请选择周',
          type: 'warning',
        })
        return
      }
      const params = {
        year:this.formData.time.substring(0,4),
        month:this.formData.time.substring(4,6),
        sourceGastype:'1',
        stationTypes:this.formData.zhanDianType,
        tonnages:this.formData.dunwei,
        fuelTypes:this.formData.ranliaoType,
        ...curSelectedWeek
      }
      window.location.assign(
          exportProvinceWSimplify({
            reqId,
            ...params
          })
      )
    },
    onWeekDialogCommand(params) {
      switch (params.type) {
        case 'ok':
          console.log(params)
          window.location.assign(http.getWeekCarOperateExport3({
            ...params.data,
            ...this.formData
          }))
          this.showWeekDialog = false
          break
        case 'close':
          this.showWeekDialog = false
          break
        default:
          break
      }
    },
    exFun(){
      this.params={
        year:this.formData.time.substring(0,4),
        month:this.formData.time.substring(4,6),
        stationTypes:this.formData.zhanDianType,
        tonnages:this.formData.dunwei,
        fuelTypes:this.formData.ranliaoType,
      }
      this.showExport = true
    },
    closeProAll(curr) {
      this[curr] = false
    },
    seeDevLog(row) {
      this.devLogIs = true
      this.currRow = row
    },
    seeTopFive(row) {
      this.seeTopFiveIs = true
      this.currRow = row
    },
    changeSearch() {
      if (this.value1) {
        this.tableHeight1 = this.tableHeight - 120
      } else {
        this.tableHeight1 = this.tableHeight
      }
    },
    async getPrInter() {
      const {data} = await http.getCountyAreaList({code: '0', type: '1', areaType: 'PROVINCE'})
      this.areaListPr = data
          .map(item => ({
            value: item.code,
            label: item.name,
            leaf: false
          }));
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'CITY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: code == '110000' || code == '120000' || code == '500000' || code == '310000' || code == '900000' ? true : false
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    propsData() {
      const vm = this
      return {
        lazy: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const {level, value} = node;
          if (level === 1) {
            resolve(await vm.getCiInter(value, level));
          } else if (level === 2) {
            resolve(await vm.getCuInter(value, level));
          } else {
            resolve([])
          }
        }
      }
    },
    getListP(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        resolve(nodes);
      })
    },
    getCityDataVal(row){
      let curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
      this.$router.push({
        path: 'carStopXiaBrandWeekT',
        query: {
          provCode: row.provcode,
          ...curSelectedWeek
        }
      })
    },
    getCityDataValXia(row){
      console.log(row.provcode)
      let curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
      this.$router.push({
        path: 'carStopNengBrandWeekT',
        query: {
          provCode: row.provcode,
          ...curSelectedWeek
        }
      })
    },
    toDetail(row) {
      this.isShowMes = true
      this.nrData = row
    },
    changeDetail() {
      this.isShowMes = false
    },
    onChangePage(index) {
      this.index = index
      this.getData(2)
    },
    onSearch() {
      this.index = 1
      this.total = 0
      this.getData(2)
    },
    getData(num = 2) {
      console.log(this.formData)
      let curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
      if (!curSelectedWeek) {
        this.$message({
          message: '请选择周',
          type: 'warning',
        })
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      console.log(this.formData.time)
      const params = {
        pageNum: this.index,
        pageSize: this.pageSize,
        year:this.formData.time.substring(0,4),
        month:this.formData.time.substring(4,6),
        sourceGastype:'1',
        stationTypes:this.formData.zhanDianType,
        tonnages:this.formData.dunwei,
        fuelTypes:this.formData.ranliaoType,
        ...curSelectedWeek
        //
        // time: this.formData.time,
        // isRecord: this.formData.devLog,
        // companyName: this.formData.companyName,
        // devUser: this.formData.cmpnanyDevUser,
        // reachStatus: this.formData.reachStatus,
        // cardType: this.formData.cardType,
        // vehicleCountMask: this.formData.vehicleCountMask,
        // mileageMask: this.formData.mileageMask,
        // percentage: this.formData.percentage,
      }

      // this.tableData = []
      http
          .provinceStatisticsW(params)
          .then((e) => {
            loading.close();
            if (200 != e.code) {
              this.$message({
                message: e.message || '数据获取出错',
                type: 'error',
              })
              return
            }

            if (e.data.length == 0) {
              this.tableData = []
              return;
            }
            if (e.data.time) {
              this.formData.time = e.data.time
            }
            this.tableData = e.data.dataList.map((_) => {
              // _.decryptedCompanyName = false
              // _.companyCreditCodeIs = false
              // _.cmpnanyDevStartTime = _.devStartTime != '-' ? Util.format(new Date(_.devStartTime * 1).getTime(), "yyyy-MM-dd") : '-'
              // _.cmpnanyDevEndTime = _.devEndTime != '-' ? Util.format(new Date(_.devEndTime * 1).getTime(), "yyyy-MM-dd") : '-'
              // _.companyCardStatusText = this.getNmae(Util.companyCardStatusOption, _.companyCardStatus)
              // _.companyDevStatusText = this.getNmae(Util.devStatusOption, _.devStatus)
              // _.cardTypeText = this.getNmae(Util.cardTypeOption, _.cardType)
              // _.reachStatusText = this.getNmae(Util.reachStatusOptions, _.reachStatus)
              return _
            })
            this.total = e.data.total
            this.index = e.data.pageNum
          })
          .catch((err) => {
            console.error(err)
            this.curDate = ''
            loading.close();
          })
    },
    getNmae(allData, val) {
      let curr = allData.filter(item => {
        return item.value == val
      })
      if (curr.length > 0) {
        return curr[0].label
      } else {
        return '-'
      }
    },
    onWeekPopOverCommand(params) {
      switch (params.type) {
        case 'default-week':
          this.onDebounceSearch()
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}
.proTextSty{
  font-size: 14px;
}
.tableTitleSty{
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  margin-top: 10px;
}
.searchBtn {
  background: #41B883;
  color: #ffffff;
}

.wrapper {
  padding: 20px;
  background: #fff;

  .header {
    //margin-bottom: 20px;
    margin-top: 20px;
  }
}

/deep/ .el-table__empty-block {
  width: 100% !important;
}

/deep/ .el-form--inline .el-form-item {
  margin-right: 10px;
}

.pageBlock {
  display: flex;
  margin-top: 20px;
}
</style>
<style lang="stylus">
.el-cascader-menu {
  overflow: hidden;
}
</style>
